/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBarBasic: {
  name: 'bar-basic';
  data: string;
} = {
  name: 'bar-basic',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M21 4a1 1 0 1 0-2 0v16a1 1 0 1 0 2 0V4Zm-5 4a1 1 0 1 0-2 0v12a1 1 0 1 0 2 0V8Zm-6 3a1 1 0 0 1 1 1v8a1 1 0 1 1-2 0v-8a1 1 0 0 1 1-1Zm-4 5a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0v-4Z" fill="currentColor"/></svg>`,
};
